import moment from 'moment'

import { normalizeStats } from './helpFunctions'

import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'
const StoreRepository = RepositoryFactory.get('store')

const SET_LOADING = 'SET_LOADING'
const SET_STATS = 'SET_STATS'
const SET_STATS_PREVIOUS_PERIOD = 'SET_STATS_PREVIOUS_PERIOD'
const SET_PREVIOUS_PERIOD_DATES = 'SET_PREVIOUS_PERIOD_DATES'

const summedStatsDefaultValue = () => ({
  clicks: 0,
  cost: 0,
  avgOrderValue: 0,
  nrOfOrders: 0,
  orderValue: 0,
  uniqueLinks: 0,
  uniqueUsers: 0,
})

export default {
  namespaced: true,
  state: {
    summedStatsPreviousPeriod: summedStatsDefaultValue(),
    summedStats: summedStatsDefaultValue(),
    previousPeriod: null,
    perDay: [],
    perSourcePerDay: [],
    loading: true,
  },
  getters: {
    summedStats: (state) => state.summedStats,
    summedStatsPreviousPeriod: (state) => state.summedStatsPreviousPeriod,
    statsPerDay: (state) => state.perDay,
    statsPerSourcePerDay: (state) => state.perSourcePerDay,
    previousPeriod: (state) => state.previousPeriod,
    loading: (state) => state.loading,
  },
  mutations: {
    [SET_STATS]: (state, stats) => {
      state.summedStats = {
        clicks: stats.clicks,
        cost: stats.cost,
        avgOrderValue: stats.avgOrderValue,
        nrOfOrders: stats.nrOfOrders,
        orderValue: stats.orderValue,
        uniqueLinks: stats.uniqueLinks,
        uniqueUsers: stats.uniqueUsers,
      }
      state.perDay = stats.perDay
      state.perSourcePerDay = stats.perSourcePerDay
    },
    [SET_STATS_PREVIOUS_PERIOD]: (state, stats) => {
      state.summedStatsPreviousPeriod = {
        clicks: stats.clicks,
        cost: stats.cost,
        avgOrderValue: stats.avgOrderValue,
        nrOfOrders: stats.nrOfOrders,
        orderValue: stats.orderValue,
        uniqueLinks: stats.uniqueLinks,
        uniqueUsers: stats.uniqueUsers,
      }
    },
    [SET_PREVIOUS_PERIOD_DATES]: (state, previousPeriod) => (state.previousPeriod = previousPeriod),
    [SET_LOADING]: (state, loading) => (state.loading = loading),
  },
  actions: {
    async fetchStatistics({ commit, rootGetters }) {
      commit(SET_LOADING, true)
      const dateRange = rootGetters['user/dataDateRange']

      try {
        const { data } = await StoreRepository.getClicksPerDay(
          rootGetters['user/token'],
          rootGetters['shop/shopId'],
          {
            date: { from: dateRange.start, to: dateRange.end },
          },
        )
        commit(SET_STATS, normalizeStats(data))
        const previousPeriod = getPreviousPeriod(dateRange)
        commit(SET_PREVIOUS_PERIOD_DATES, previousPeriod)

        const { data: clicksData } = await StoreRepository.getClicksPerDay(
          rootGetters['user/token'],
          rootGetters['shop/shopId'],
          {
            date: { from: previousPeriod.start, to: previousPeriod.end },
          },
        )
        commit(SET_STATS_PREVIOUS_PERIOD, normalizeStats(clicksData))
      } finally {
        commit(SET_LOADING, false)
      }
    },
  },
}

function getPreviousPeriod({ key, start: startDate, end: endDate }) {
  const dateFormat = 'YYYY-MM-DD'
  const start = moment(startDate)
  const end = moment(endDate)

  if (key === 'lastMonth') {
    return {
      start: start.subtract(1, 'month').startOf('month').format(dateFormat),
      end: start.subtract(1, 'month').endOf('month').format(dateFormat),
    }
  }
  if (key === 'thisMonth') {
    return {
      start: start.subtract(1, 'month').startOf('month').format(dateFormat),
      end: moment().subtract(1, 'month').format(dateFormat),
    }
  }
  if (key === 'thisYear') {
    return {
      start: start.subtract(1, 'year').startOf('month').format(dateFormat),
      end: moment().subtract(1, 'year').format(dateFormat),
    }
  }

  const diffInDays = end.diff(start, 'days') + 1
  return {
    start: start.subtract(diffInDays, 'days').format(dateFormat),
    end: end.subtract(diffInDays, 'days').format(dateFormat),
  }
}
